import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { RoomAddress } from 'app/cs/psv/common/model/person/psvPersonProfile';

@Component( {
    selector: 'psv-person-detail-view-addresses',
    templateUrl: './person-detail-view-addresses.component.html',
    preserveWhitespaces: false
} )
export class PersonDetailViewAddressesComponent {

    @Input() addresses: RoomAddress[];

    constructor() { }

    isEmpty( input: any ): boolean {
        return _.isNil( input ) || _.isEmpty( input );
    }
}
